import { type DependencyList, useEffect } from 'react';
import { type AsyncState, useAsyncFn } from './useAsyncFn';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- same as the built-in ReturnType
type PromiseType<P extends Promise<any>> = P extends Promise<infer T> ? T : never;

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- same as the built-in ReturnType
type FunctionReturningPromise = () => Promise<any>;

type StateFromFunctionReturningPromise<T extends FunctionReturningPromise> = AsyncState<PromiseType<ReturnType<T>>>;

export function useAsync<T extends FunctionReturningPromise>(
    fn: T,
    deps: DependencyList = []
): StateFromFunctionReturningPromise<T> {
    const [state, callback] = useAsyncFn(fn, deps, { loading: true });

    useEffect(() => {
        callback();
    }, [callback]);

    return state;
}
